import { document } from "postcss";
import Swiper from "swiper";
import { Pagination, FreeMode } from "swiper/modules";

jQuery(document).ready(function($) {
  let options = {
    modules: [FreeMode],
    slidesPerView: 1,
    spaceBetween: 32,
    freeMode: true,
    loop: false,
    grabCursor: true,
    breakpoints: {
      640: {
        slidesPerView: 1
      },
      768: {
        slidesPerView: 1.6
      },
    },
  };

  let swiper_obj = $(".swiper");

  swiper_obj.each(function() {
    if ($(this).parent().hasClass("wp-block--jobs--carousel")) {
      console.log("Jobs carousel");
      options.slidesPerView = 1;
      options.spaceBetween = 16;
      options.modules = [FreeMode, Pagination];
      options.loop = false;
      options.freeMode = false;
      options.pagination = {
        el: ".swiper-pagination",
        clickable: true,
        type: "bullets",
      };

      options.breakpoints = {
        640: {
          slidesPerView: 1,
        },
        768: {
          slidesPerView: 3.2,
        },
      };
    }

    let swiper = new Swiper($(this).get(0), options);

    console.log(options);
    console.log(swiper);

    $(".swiper-button-next").on("click", function() {
      swiper.slideNext();
    });

    $(".swiper-button-prev").on("click", function() {
      swiper.slidePrev();
    });
  });

  $(".wp-block--accordion--title").click(function(e) {
    e.preventDefault();
    console.log("Toggle open");
    $(this).parent().toggleClass("open");
  });

  $(".wp-block--job--accordion--header").click(function(e) {
    e.preventDefault();
    $(this).parent().toggleClass("open");
  });

  let padding = 40;
  $(".wp-block--job--accordion--body").each(function() {
    let elem = $(this).find(".wp-block--job--accordion--body--wrapper");
    let height = elem.height();

    $(this).css("--height", height + padding + "px");
  });
});

jQuery(document).ready(() => {
  const vid = document.getElementById("hero-video");
  const player = videojs(vid);

  player.ready(function() {
    player.play();
  });
});

jQuery(document).ready(($) => {
  // Calculate read time for articles
  let article_body = $(".article--content--body--content");
  let article_body_text = article_body.text();
  let words = article_body_text.split(" ").length;
  let words_per_minute = 200;
  // Calculate read time in seconds so we can decide if it is seconds, minutes or hours
  let read_time_seconds = (words / words_per_minute) * 60;
  let read_time_elem = $(".read-time");
  let suffix = "";
  let read_time_real = 0;

  if (read_time_seconds < 60) {
    suffix = "< 1 min";
    read_time_real = null;
  }

  if (read_time_seconds > 60) {
    suffix = "mins";
    read_time_real = read_time_seconds / 60;
  }

  if (read_time_seconds > 3600) {
    suffix = "hours";
    read_time_real = read_time_seconds / 3600;
  }

  if (read_time_seconds > 86400) {
    suffix = "days";
    read_time_real = read_time_seconds / 86400;
  }

  if (read_time_real) {
    read_time_elem.text(`${Math.round(read_time_real)} ${suffix}`);
  } else {
    read_time_elem.text(`${suffix}`);
  }
});

jQuery(document).ready(($) => {
  // Add a wrapper to the sub-menu
  $(".menu-item-has-children>.sub-menu").wrapInner(
    '<div class="sub-menu-wrapper"></div>'
  );

  $(".sub-menu-wrapper").each(function() {
    let children = $(this).children().length;
    let columns = Math.ceil(children / 6);

    if (children < 6) {
      columns = 1;
    }

    $(this).css("--columns", columns);
  });

  $(".menu-item-has-children>.sub-menu").css(
    "--top-offset",
    ($("#masthead").height() + ($('#wpadminbar').length ? $("#wpadminbar").height() : '')) + "px",
  );

  $('body').css(
    '--top-offset',
    ($("#masthead").height() + ($('#wpadminbar').length ? $("#wpadminbar").height() : '')) + "px");

  $(".menu-item-has-children").click((e) => {
    e.preventDefault();

    $('.menu-item-has-children').not($(e.target).parent()).removeClass("menu-open");

    if ($(e.target).parent().hasClass("menu-open")) {
      $("body").removeClass("show-underlay");
      $(e.target).parent().removeClass("menu-open");
    } else {
      $("body").addClass("show-underlay");
      $(e.target).parent().addClass("menu-open");
    }
  });

  $('.menu-item').click((e) => {
    let clicked = e.target;

    if (!$(clicked).parent().hasClass('menu-item-has-children')) {
      e.stopPropagation();
    }
  });
});

jQuery(document).ready(($) => {
  $(".page-push").css("--header-height", $("#masthead").height() + "px");
  $("body").css("--header-height", $("#masthead").height() + "px");
});

jQuery(window).on('resize', () => {
  let current, previous;

  current = jQuery("#masthead").height();
  previous = jQuery(".page-push").css("--header-height");

  current = current + "px";
  current = current.toString();

  // We only want to update the css variable if the height has changed to avoid unnecessary repaints
  if (current != previous) {
    console.log("Sizes are different, updating");
    jQuery(".page-push").css("--header-height", jQuery("#masthead").height() + "px");
    jQuery("body").css("--header-height", jQuery("#masthead").height() + "px");
  }

  jQuery(".menu-item-has-children>.sub-menu").css(
    "--top-offset",
    (jQuery("#masthead").height() + (jQuery('#wpadminbar').length ? jQuery("#wpadminbar").height() : '')) + "px",
  );

  jQuery('body').css(
    '--top-offset',
    (jQuery("#masthead").height() + (jQuery('#wpadminbar').length ? jQuery("#wpadminbar").height() : '')) + "px");

  console.log(jQuery('body').css('--top-offset'));
});

jQuery(document).ready(($) => {
  $(document).on("click", ".underlay", function() {
    $(".menu-open").removeClass("menu-open");
    $(".show-underlay").removeClass("show-underlay");
  });

  $("#primary-menu").append(`
      <li>
        <div class="mobile-only menu-button-group">
          <a href="/contact-us/" class="btn btn--red">Get in touch</a>
        </div>
      </li>
  `);

  console.log("added button");
});


jQuery(document).ready(($) => {
  const animatabale = $('.has-animation, .wp-block--hero--content>.wp-block-heading');

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('animate');
      } else {
        // Animations should only happen once, so don't remove the class
      }
    });
    {
      threshold: 1.0
    }
  });

  for (let i = 0; i < animatabale.length; i++) {
    const elements = animatabale[i];

    observer.observe(elements);
    console.log(elements);
  }
});

jQuery(document).ready(($) => {
  $('.menu--toggle').click(function(e) {
    e.preventDefault();

    // If the sub-menu is open, close it 
    if ($('.sub-menu').parent().hasClass('menu-open')) {
      $('.sub-menu').parent().removeClass('menu-open');
    } else {
      // Otherwise, toggle the main menu as normal
      $('.menu').toggleClass('open');
      if ($('.menu').hasClass('open')) {
        $('body').addClass('show-underlay');
      } else {
        $('body').removeClass('show-underlay');
      }
      $('.main-navigation').toggleClass('toggled');
      $(this).toggleClass('menu-open');
    }
  });
});

jQuery(document).ready(($) => {
  $('body').on('click', '.showcase-video--close', function(e) {
    e.preventDefault();

    // Find closest showcase video and delete it from the DOM
    let video = $(this).closest('.showcase-video');

    if ($(this).parents('.modal').length) {
      $('body').trigger('modal:closed', $(this).parents('.modal'));
    }

    video.remove();
  });

  $('.play-showcase-button').click(function(e) {
    e.preventDefault();
    $('.showcase-video').addClass('show');

    let hasHeroParent = $(this).parents('.wp-block--hero').length;

    if (hasHeroParent) {
      let theParent = $(this).parents('.wp-block--hero');

      const toCopy = $('.showcase-video').clone();
      theParent.append(toCopy);

      const video = theParent.find('.showcase-video').find('.showcase-video-item').get(0);
      const player = videojs(video);

      player.play();

      player.play().catch(() => {
        console.log('Error playing video, muting and trying again');
        player.muted = true;
        player.play();
      });
    } else {
      let modal = $('.modal');
      const toCopy = $('.showcase-video').clone();

      modal.find('.modal--content--inner--wrapper').append(toCopy);

      const video = modal.find('.showcase-video').find('.showcase-video-item').get(0);

      $('body').trigger('modal:opened', modal);
      const player = videojs(video);
      player.play();

      player.play().catch(() => {
        console.log('Error playing video, muting and trying again');
        player.muted = true;
        player.play();
      });
    }
  });

  $('body').on('modal:closed', function(evt, modal) {
    $(modal).removeClass('show');
    $('body').removeClass('show-underlay');
  });

  $('body').on('modal:opened', function(evt, modal) {
    $(modal).addClass('show');
    $('body').addClass('show-underlay');
  });
});
